import React, { useEffect, useState } from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import YouTubePlayer from "./youtube-player/index";

import Box from "../Box/Box";
import { BoxProps } from "../Box/box.type";
import VideoThumbnail from "../VideoThumbnail/VideoThumbnail";

const Container = styled(Box)`
  ${css({ border: "none", borderRadius: 2 })}
  overflow: hidden;
`;

const Thumbnail = styled(VideoThumbnail)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export interface VideoPlayerProps extends BoxProps {
  title: string;
  thumbnailUrl: string;
  videoId: string;
}

const VideoPlayer = ({
  title,
  thumbnailUrl,
  videoId,
  ...props
}: VideoPlayerProps) => {
  const [playinState, setPlayinState] = useState(-1);
  const [frameId] = useState(() => Math.random().toString(36).substring(6));
  const [player, setPlayer] = useState<any | null>(null);
  const onPlay = () => {
    if (player) {
      player.playVideo()!;
    }
  };
  useEffect(() => {
    setPlayer(
      YouTubePlayer(frameId, {
        videoId: videoId,
        height: "100%",
        width: "100%",
      })
    );
  }, [frameId, videoId]);
  useEffect(() => {
    // state names
    //   "-1": "unstarted",
    //   0: "ended",
    //   1: "playing",
    //   2: "paused",
    //   3: "buffering",
    //   5: "video cued",
    if (player) {
      player.on("stateChange", function (event: any) {
        setPlayinState(event.data);
      });
    }
  }, [player]);
  return (
    <Container
      {...props}
      style={{ position: "relative" }}
      width={props.width}
      height={props.height}
    >
      <div id={frameId}></div>
      {(playinState === 2 || playinState === -1) && (
        <Thumbnail
          width={props.width}
          height={props.height}
          thumbnailUrl={thumbnailUrl}
          videoTitle="BCA cars"
          onClick={onPlay}
        ></Thumbnail>
      )}
    </Container>
  );
};

export default VideoPlayer;
